import {
    TextField,
    Button,
    Typography,
    Box,
    IconButton,
    Card,
    CardContent,
    Grid2 as Grid,
    Modal,
} from "@mui/material";
import {
    Email,
    Phone,
    Facebook,
    Instagram,
} from "@mui/icons-material";
import AccountMenu from "./Menu";
import { requestMailServ, sendMail } from "services/Mail";
import { useState } from "react";

// No hay ícono oficial de TikTok, puedes importar uno personalizado o usar otro ícono similar si lo deseas

export default function AboutUs() {
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    const [openModal, setOpenModal] = useState(false);
    const handleClose = () => setOpenModal(false);

    const onFormSubmit = async () => {
                 setTimeout(() => setOpenModal(true), 200);

        await requestMailServ()
        if (await sendMail('Juan', 'juan@gabriel.com', 'test', 'probando 1,2,3')) {
            console.info('a mostrar el modal de exito');
        } else {
            console.info('bueno a veces no funciona a la primera');

        }

    }

    return <>
        <AccountMenu />
        <Box sx={{ backgroundColor: "#fff", p: 4 }}>
            <Grid container spacing={4} justifyContent="center">
                {/* Contact Form */}
                <Grid size={6} minWidth={360}>
                    <Card sx={{ borderRadius: 4, boxShadow: 3 }}>
                        <CardContent>
                            <Typography
                                variant="h5"
                                color="primary"
                                fontWeight="bold"
                                gutterBottom
                            >
                                Get in Touch
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                Find out more about our rentals.
                            </Typography>

                            <TextField fullWidth label="Name" margin="normal" />
                            <TextField
                                fullWidth
                                label="Email"
                                type="email"
                                margin="normal"
                            />
                            <TextField fullWidth label="Phone" type="tel" margin="normal" />
                            <TextField
                                fullWidth
                                label="Message"
                                multiline
                                rows={4}
                                margin="normal"
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                sx={{ mt: 2 }}
                                onClick={onFormSubmit}
                            >
                                Submit
                            </Button>
                        </CardContent>
                    </Card>
                </Grid>

                {/* Contact Info and Map */}
                <Grid size={6} minWidth={340}>
                    <Box>
                        <Typography variant="body1" color="primary" fontWeight="bold">
                            (479) 93659252
                        </Typography>
                        <Typography variant="body2">
                            2015 S Thompson St, Springdale, AR 72764<br />
                            Tontitown, AR 72764
                        </Typography>
                        <Typography variant="body2" gutterBottom>
                            contact@superfun-nwa.com
                        </Typography>

                        <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
                            <IconButton color="primary" href="https://instagram.com">
                                <Email />
                            </IconButton>
                            <IconButton color="primary" href="https://instagram.com">
                                <Phone />
                            </IconButton>
                            <IconButton color="primary" href="https://facebook.com">
                                <Facebook />
                            </IconButton>
                            <IconButton color="primary" href="https://instagram.com">
                                <Instagram />
                            </IconButton>
                            {/* Puedes cambiar esto por un ícono válido de TikTok si tienes uno */}
                            <IconButton color="primary" href="https://tiktok.com">
                                <span style={{ fontSize: 24 }}>🎵</span>
                            </IconButton>
                        </Box>
                        <Box sx={{ mt: 3 }}>
                            {/* ✅ Mapa funcional sin API Key */}
                            <iframe
                                title="map"
                                width="100%"
                                height="200"
                                style={{ borderRadius: 8 }}
                                src="https://maps.google.com/maps?q=36.16885680548475,-94.23899704662325&hl=es&z=14&output=embed"
                                allowFullScreen
                            />
                        </Box>
                    </Box>
                </Grid>
            </Grid>
            <Modal open={openModal} >
                <Box sx={style}>
                    <Grid container>
                        <Grid size={11} />
                        <Grid size={1}>
                            <Button onClick={handleClose}>X</Button>
                        </Grid>
                    </Grid>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Thanks for contacting us!
                    </Typography>
                    <Typography>We will contact you shortly, meanwhile explore our website.</Typography>
                    <Grid container>
                        <Grid size={10} />
                        <Grid size={2}>
                            <Button variant="contained" color="error" onClick={handleClose} >Close</Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </Box>
    </>;
}
